import React from 'react';
import { motion } from 'framer-motion';
interface QuietConfidenceProps {
  text: string;
}
export function QuietConfidence({
  text
}: QuietConfidenceProps) {
  return <section className="py-24 bg-transparent relative z-10 flex items-center justify-center overflow-hidden" data-id="element-765">
      <div className="absolute left-0 right-0 top-1/2 h-px bg-gradient-to-r from-transparent via-white/5 to-transparent -translate-y-1/2" data-id="element-766" />

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-50px'
    }} transition={{
      duration: 1,
      ease: 'easeOut'
    }} className="bg-[#050505] px-8 py-2 relative z-10" data-id="element-767">
        <p className="text-xs md:text-sm font-medium text-gray-500 uppercase tracking-[0.3em] text-center" data-id="element-768">
          {text}
        </p>
      </motion.div>
    </section>;
}